module.exports = __webpack_public_path__ + "static/img/summer.ff67f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/s_tree2_adult/summer.png
// module id = qfBd
// module chunks = 1